<template lang="html">
  <div class="features detail-intro">
    <div class="container">
      <div class="row" itemscope itemtype="https://schema.org/Car">
        <div class="col-md-6 intro">
          <div class="row">
            <div class="col-md-12">
              <ul class="fast-menu">
                <nuxt-link v-for="(type, key) in model.motor" :to="getRoute(type)"
                           @click.native="reportEvent('type', type)" :key="key">
                  <li
                    :class="typeselected.cTypenaam_2 != type.typeinformation[0].cTypenaam_2 ? 'no-selected': 'border-color'">
                    {{ type.cTypenaam_1 }}<span
                    v-if="!isNaN(Math.round(parseInt(type.typeinformation[0].Vermogen_elektromotor_kW)*1.36))"> ({{
                      Math.round(parseInt(type.typeinformation[0].Vermogen_elektromotor_kW) * 1.36)
                    }}pk)</span>
                  </li>
                </nuxt-link>
              </ul>
            </div>
          </div>

          <h1 itemprop="name"><span itemprop="brand">{{ type.cMerknaam }}</span> {{ type.cModelnaam }}
            {{ type.cTypenaam_1 }}<br> met {{ Math.round(type.nIngeschatteActieradius) }} km actieradius</h1>

          <p itemprop="description">
            De <a :href="'/elektrische-auto/'+type.nModelID+'/'+type.cMerknaam+'-'+type.cModelnaam.replace(/\s+/g, '-')"
                  itemprop="url">{{ type.cMerknaam }} {{ type.cModelnaam }}  {{ type.cTypenaam_1 }} met {{ Math.round(parseInt(type.Vermogen_elektromotor_kW) * 1.36) }}pk</a> is een elektrische auto uit het
            {{ segmentCodes[type.cSegmentAdvanced] }} segment ({{ type.cSegmentAdvanced }})
            en is verkrijgbaar vanaf <b v-if="type.nConsumentenprijs != null">&euro;

            {{ String(type.nConsumentenprijs).replace(/\B(?=(\d{3})+(?!\d))/g, ".") }},-</b>

            <b v-else>&euro;n.n.b,-</b>
           . Hij heeft een accucapaciteit van {{ model.motor[0].Accu_capaciteit_kWh }} <span
            v-if="model.motor[0].Accu_capaciteit_kWh != model.motor[model.motor.length-1].Accu_capaciteit_kWh">tot {{
              model.motor[model.motor.length - 1].Accu_capaciteit_kWh
            }}</span>
            kWh en is qua lengte <b>{{ getLength(type.nLengte_mm) }}</b> dan de gemiddelde auto binnen dit segment.

          </p>
          <p itemprop="description" v-if="motorTypes && motorTypes.length > 0">
            De {{ type.cMerknaam }} {{ type.cModelnaam }}  {{ type.cTypenaam_1 }} is beschikbaar in de <span v-if=" motorTypes[0].typeinformation.length > 1">uitvoeringen</span><span v-else>uitvoering</span>

           <span v-for="(type, index) in motorTypes[0].typeinformation">{{type.Uitvoering2}}<span v-if="(index+1) === motorTypes[0].typeinformation.length ">.</span> <span v-else-if="(index+1) === motorTypes[0].typeinformation.length -1 "> en </span>  <span v-else>, </span></span>

          </p>

          <span v-if="model.GetSegmentCarsAdvanced?.length > 0">
            In het {{ segmentCodes[type.cSegmentAdvanced] }} segment is niet alleen de elektrische {{ type.cMerknaam }} {{
              type.cModelnaam
            }} leverbaar, maar ook de
            <a :href="'/elektrische-auto/'+car.nModelID+'/'+car.cMerknaam+'-'+car.cModelnaam.replace(/\s+/g, '-')"
               v-for="(car, index) in model.GetSegmentCarsAdvanced">{{ car.cMerknaam }} {{ car.cModelnaam }}<span
              v-if="(index+1) == model.GetSegmentCarsAdvanced.length">.</span> <span v-else>, </span> </a>
          </span>
          </p>

          <p itemprop="description">
            De {{ type.cMerknaam }} {{ type.cModelnaam }} {{ type.cTypenaam_1 }}  heeft een ingeschatte actieradius van
            {{ Math.round(type.nIngeschatteActieradius) }} km die je <b>{{ getRange(type.nIngeschatteActieradius) }}</b>
            kan noemen.
            Daarbij heeft hij een topsnelheid van {{ type.nTopsnelheid }} km/h, wat
            <b>{{ getTopSpeed(type.nTopsnelheid) }}</b> is dan het gemiddelde. Van 0-100 accelereert de elektrische
            {{ type.cMerknaam }} {{ type.cModelnaam }} {{ type.cTypenaam_1 }} in {{ type.nAcceleratie }} seconden,
            wat <b>{{ getAcceleration(type.nAcceleratie) }}</b> is dan een auto binnen het
            {{ segmentCodes[type.cSegmentAdvanced] }} segment.
          </p>

          <!-- <p itemprop="description">
            Je kan deze {{type.cMerknaam}} {{type.cModelnaam}} <span v-if="getBsnelladen(type.Snelladen) == 'niet'">{{getBsnelladen(type.Snelladen)}}</span> snelladen<span v-if="getBsnelladen(type.Snelladen) == 'niet'">.</span>
            <span v-if="getBsnelladen(type.Snelladen) == 'wel'"> met een snelheid van {{Math.round(type.nSnellaadSnelheid)}} km/u.
            Dat doe je doormiddel van een <b>{{fastLoaders[type.cSnellaadkabel.replace(/\s+/g, '')]}}</b> aansluiting. <span v-if="type.cMerknaam == 'Tesla'">Onderweg is het natuurlijk mogelijk om via de <a href="https://www.tesla.com/nl_NL/destination-charging" target="_blank">Tesla Superchargers</a> op te laden.</span>
            Thuis laden kan ook met een maximale snelheid van {{Math.round(type.nLaadsnelheid)}} km/u. Dan is je auto binnen <span v-if="String(type.nLaadtijd).split('.')[0] > 0">{{String(type.nLaadtijd).split('.')[0]}} uur en</span> {{formatTime(type.nLaadtijd)}} minuten vol.
            </span>
          </p> -->

          <ul class="fast-menu">
            <li @click="reportEvent('scrollto-ev-gegevens', type)" v-scroll-to="'#actieradius'">EV gegevens</li>
            <li @click="reportEvent('scrollto-actieradius', type)" v-scroll-to="'#actieradius'">Actieradius &amp;
              Verbruik
            </li>
            <li @click="reportEvent('scrollto-restwaarde', type)" v-scroll-to="'#restwaarde'">Restwaarde</li>
            <li @click="reportEvent('scrollto-opties', type)" v-scroll-to="'#options'">{{ type.cMerknaam }} Opties</li>
          </ul>

        </div>
        <div class="col-md-6">
          <div class="row calculation-headers">

            <div class="col-md-6">
              <h2 class="text-center text-color mobile-margin-top">{{ type.WLTPsoort }}</h2>
              <div class="item bordered">
                <p>{{ type.nActieradius }} km</p>
                <h4>Actieradius</h4>
              </div>
              <div class="item bordered">
                <p class="verbruik--item">{{ type.Gem_verbruik_electrisch_kwh }} kWh</p>
                <h4 class="verbruik--item">Verbruik</h4>
                <i class="verbruik--item">o.b.v. fabrieks actieradius</i>
              </div>
            </div>

            <div class="col-md-6">
              <h2 class="text-center text-colored mobile-margin-top">Praktisch <a href="#disclaimer_praktijk" title="Hoe bereken wij het praktijkverbruik?"> <i class="mdi mdi-information-outline"
                ></i></a></h2>
              <div class="item colored">
                <p>{{ Math.round(type.nIngeschatteActieradius) }} km</p>
                <h4>Actieradius </h4>
              </div>
              <div class="item colored">
                <p class="verbruik--item">{{ Math.ceil(type.nIngeschatVerbruik * 10) / 10}} kWh</p>
                <h4 class="verbruik--item">Verbruik</h4>
                <i class="verbruik--item">o.b.v. praktische actieradius <br> (inclusief laadverlies)</i>
              </div>
            </div>


            <div class="col-md-12">
              <p itemprop="description" style="margin-top:23px;">
                Je kan deze {{ type.cMerknaam }} {{ type.cModelnaam }} {{ type.cTypenaam_1 }} <span
                v-if="getBsnelladen(type.Snelladen) == 'niet'">{{ getBsnelladen(type.Snelladen) }}</span> snelladen<span
                v-if="getBsnelladen(type.Snelladen) == 'niet'">.</span>
                <span
                  v-if="getBsnelladen(type.Snelladen) == 'wel'"> met een snelheid van {{
                    Math.round(type.nSnellaadSnelheid)
                  }} km/u.
            <span v-if="type.cSnellaadkabel"> Dat doe je doormiddel van een <b>{{ fastLoaders[type.cSnellaadkabel.replace(/\s+/g, '')] }}</b> aansluiting.</span> <span
                    v-if="type.cMerknaam == 'Tesla'">Onderweg is het natuurlijk mogelijk om via de <a
                    href="https://www.tesla.com/nl_NL/destination-charging" target="_blank">Tesla Superchargers</a> op te laden.</span>
            Thuis laden kan ook met een maximale snelheid van {{ Math.round(type.nLaadsnelheid) }} km/u. Dan is je auto binnen <span
                    v-if="String(type.nLaadtijd).split('.')[0] > 0">{{
                      String(type.nLaadtijd).split('.')[0]
                    }} uur en</span> {{ formatTime(type.nLaadtijd) }} minuten vol.
            </span>
              </p>
              <!-- <p style="margin-top:27px;" itemprop="description">

                De kosten van het verbruik per kilometer van de {{type.cMerknaam}} {{type.cModelnaam}} bedragen ongeveer  <b>{{Math.round(type.nIngeschatVerbruik*0.50)}} cent </b>. Dit is {{ Math.round( (verbruikSegment[type.cSegmentAdvanced] * 1.5) - (type.nIngeschatVerbruik*0.50) )}} cent minder dan een vergelijkbare benzine auto in het {{segmentCodes[type.cSegmentAdvanced]}} segment, waar het werkelijk verbruik ongeveer {{Math.round(verbruikSegment[type.cSegmentAdvanced]*1.45)}} cent per kilometer is.
                Dus wanneer je 35.000 kilometer per jaar rijdt
                kan de besparing oplopen tot <b>&euro; {{formatCalc( (( verbruikSegment[type.cSegmentAdvanced] * 1.45) - (type.nIngeschatVerbruik*0.50)) * 35000 )}},- </b> ten opzichte van een benzine auto in dit {{segmentCodes[type.cSegmentAdvanced]}} segment.

              </p> -->
            <transition name="slide-right">
              <div v-show="showNews" style="    position: fixed;    z-index: 1000;    bottom: 20px;    right: 20px;    ">
                <news-card  :modelId="type.nModelID" class="d-none d-lg-flex" />
              </div>
            </transition>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import NewsCard from "./NewsCard";

export default {
  components: {
    NewsCard,
  },
  props: ['type', 'model'],
  watch: {
    'type': function () {
      this.typeselected = this.type
    },
  },
  data() {
    return {
      typeselected: null,
      segmentCodes: {
        A: 'submini\'s',
        B: 'kleine auto\'s',
        C: 'kleine middenklasse',
        D: 'middenklasse',
        E: 'hogere middenklasse',
        F: 'grote auto\'s',
        GA: 'sportieve submini\'s',
        GB: 'sportieve kleine auto\'s',
        GC: 'sportieve kleine middenklasse',
        GD: 'sportieve middenklasse',
        GE: 'sportieve hogere middenklasse',
        GF: 'sportieve grote auto\'s',
        GG: 'sportieve modellen ',
        H: 'supercars',
        I: 'grote en luxueuze auto',
        JA: 'MPV submini\'s',
        JB: 'MPV kleine auto\'s',
        JC: 'MPV kleine middenklasse',
        JD: 'MPV middenklasse',
        JE: 'MPV hogere middenklasse',
        JF: 'MPV grote auto\'s',
        LA: 'SUV submini\'s',
        LB: 'SUV kleine auto\'s',
        LC: 'SUV kleine middenklasse',
        LD: 'SUV middenklasse',
        LE: 'SUV hogere middenklasse',
        LF: 'SUV grote auto\'s',
        LI: 'SUV grote en luxueuze auto',
        N: 'bestelauto’s'
      },
      lengthSegment: {
        A: 3552,
        B: 4013,
        BA: 4217,
        BB: 5155,
        BC: 6071,
        BD: 4921,
        C: 6071,
        D: 4755,
        E: 4996,
        F: 5131,
        G: 4265,
        GA: 3059,
        GC: 4078,
        GD: 4524,
        GE: 4598,
        GF: 4770,
        GH: 4751,
        H: 4651,
        I: 5411,
        JB: 4128,
        JC: 4531,
        LA: 3734,
        LB: 4196,
        LC: 4407,
        LD: 4621,
        LE: 4896,
        LF: 5014,
        LI: 5137,
        N: 5158,


      },
      range: [
        {
          km: 100,
          type: 'slecht'
        },
        {
          km: 200,
          type: 'matig'
        },
        {
          km: 300,
          type: 'redelijk'
        },
        {
          km: 400,
          type: 'goed'
        },
        {
          km: 500,
          type: 'zeer goed'
        },
        {
          km: 501,
          type: 'uitstekend'
        }
      ],
      topSpeedSegment: {
        A: 154,
        B: 186,
        BA: 156,
        BB: 162,
        BC: 145,
        BD: 188,
        C: 204,
        D: 219,
        E: 218,
        F: 255,
        G: 222,
        GA: 164,
        GC: 218,
        GD: 241,
        GE: 265,
        GF: 263,
        GH: 308,
        H: 303,
        I: 278,
        JB: 186,
        JC: 209,
        LA: 125,
        LB: 183,
        LC: 189,
        LD: 196,
        LE: 214,
        LF: 225,
        LI: 275,
        N: 161
      },

      kwalifications: [
        {perc: 5, text: 'iets'},
        {perc: 10, text: 'enigszins'},
        {perc: 15, text: 'veel'},
        // {perc: 20, text: 'heel veel'},
        // {perc: 21, text: 'zeer veel'},
      ],
      accelerationSegment: {
        A: 12.1,
        B: 10.3,
        BA: 11.6,
        BB: 10.1,
        BC: 1.2,
        BD: 8,
        C: 9.1,
        D: 7.1,
        E: 7.1,
        F: 4.8,
        G: 6.5,
        GA: 7,
        GC: 7.1,
        GD: 5.9,
        GE: 5,
        GF: 4.8,
        GH: 3.7,
        H: 3.9,
        I: 4.5,
        JB: 10.9,
        JC: 8.9,
        LA: 17.3,
        LB: 10.3,
        LC: 9.3,
        LD: 7.8,
        LE: 6.4,
        LF: 6.1,
        LI: 4.7,
        N: 10
      },

      verbruikSegment: {
        A: 3.4,
        B: 5,
        BA: 7.1,
        BB: 6.2,
        BC: 7.2,
        BD: 8.2,
        C: 4.9,
        D: 5.1,
        E: 5.8,
        F: 7,
        G: 8.8,
        GA: 6.8,
        GC: 6.8,
        GD: 7.7,
        GE: 8.8,
        GF: 10.5,
        GH: 10.8,
        H: 11.4,
        I: 13.2,
        JB: 5.5,
        JC: 4.9,
        LA: null,
        LB: 5.3,
        LC: 5.3,
        LD: 4.5,
        LE: 6.9,
        LF: 8.3,
        LI: 11.1,
        N: 5.4
      },

      fastLoaders: {
        ccs: 'CCS Combo 2',
        ccs2: 'CCS Combo 2',
        type2: 'Mennekes',
        cdm: 'CHAdeMO',
        2: 'Type 2',
        1: 'Type 1',
        sc: 'Tesla Supercharger'
      },
      showNews: false
    }
  },
  created() {
    this.typeselected = this.type
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    reportEvent(event, type) {
      this.$gtag('event', `clicked-on-${event}`, {
        event_category: 'Model Overview',
        event_label: `${type.cMerknaam}-${type.cModelnaam}-${type.cTypenaam_1}`,
        value: type.nTypeIDHist,
      });
    },
    getLength(length) {
      if (length > this.lengthSegment[this.type.cSegmentAdvanced])
        return 'groter'
      return 'kleiner'
    },
    getRange(radius) {
      // radius = 500;
      if (radius <= this.range[0].km)
        return this.range[0].type

      if (radius > this.range[this.range.length - 1].km)
        return this.range[this.range.length - 1].type

      for (let r in this.range) {
        if (radius < this.range[parseInt(r)].km)
          return this.range[parseInt(r)].type;
      }
    },
    getTopSpeed(speed) {
      let percentagec = 100 / this.topSpeedSegment[this.type.cSegmentAdvanced] * parseInt(speed)
      let percentage = Math.abs(100 - (parseInt(speed) / this.topSpeedSegment[this.type.cSegmentAdvanced] * 100))
      // console.log(percentage);
      let type = ' lager'
      if (percentagec > 100)
        type = ' hoger'

      for (let s in this.kwalifications)
        if (percentage < this.kwalifications[s].perc)
          return this.kwalifications[s].text + type;

      return this.kwalifications[this.kwalifications.length - 1].text + type;
    },
    getAcceleration(acc) {
      let percentagec = 100 / this.accelerationSegment[this.type.cSegmentAdvanced] * parseInt(acc)
      let percentage = Math.abs(100 - (parseInt(acc) / this.accelerationSegment[this.type.cSegmentAdvanced] * 100))
      // console.log(percentage);
      let type = ' sneller'
      if (percentagec > 100)
        type = ' langzamer'

      for (let s in this.kwalifications)
        if (percentage < this.kwalifications[s].perc)
          return this.kwalifications[s].text + type;

      return this.kwalifications[this.kwalifications.length - 1].text + type;
      return 'langzamer';
    },
    getBsnelladen(value) {
      if (value == 'j')
        return 'wel';
      return 'niet'
    },
    getVerbruiktSegment() {
      return 40;
    },
    formatCalc(price) {
      return ((price / 100).toFixed(0)).replace(/\./g, ',').toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    },
    formatTime(time) {
      return Math.round(parseFloat(0 + '.' + String(time).split('.')[1]) * 60)
    },
    getRoute(type) {
      const seoModel = type.typeinformation[0].cMerknaam + '-' + type.typeinformation[0].cModelnaam.replace(/\s+/g, '-');
      const id = type.typeinformation[0].nModelID

      const type1 = type.typeinformation[0].cTypenaam_1.replace(/\s+/g, '-')
      const type2 = type.typeinformation[0].cTypenaam_2.replace(/\s+/g, '-')


      return '/elektrische-auto/' + id + '/' + seoModel + '/' + type1 + '-' + type2;
    },

    handleScroll(e){
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 300) {
        this.showNews = false
        return
      }
      // remove below is down scroll invisible false
      this.showNews = true
      return
    }

  },

  computed:{
    motorTypes() {
      return this.model.motor.filter(motor => motor.cTypenaam_1 === this.type.cTypenaam_1);
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-intro {
  .fast-menu {
    padding-top: 0;
  }

  .fast-menu li {
    cursor: pointer;
    margin-bottom: 15px !important;
  }

  .no-selected {
    background: #fff;
    color: #2ecc71;
    border: 2px solid #2ecc71;
  }

  .border-color {
    border: 2px solid #2ecc71;
  }
}

.features {
  .item {
    i {
      font-size: 11px;
      color: #666;
    }
  }

  select {
    margin-top: -25px;
  }
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-right-move {
  transition: all .5s;
}
.slide-right-enter,
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(100%) translateX(+500px);
}

@media only screen and (max-width: 600px) {
  .mobile-margin-top{
    margin-top: 1rem;
  }
}
</style>
